import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { logger } from 'app/core/util/logger';
import { Observable } from 'rxjs';
import * as fromRoot from 'app/core/store';
import { appSettings } from 'app/appSettings';
import { ClearSelectedCustomerAction } from 'app/core/store/session/selected-customer/select-customer.actions';
import { goAction } from '../store/router/router.actions';

/**
 * Guard to synchronously clear orders filter & result
 */
@Injectable({ providedIn: 'root' })
export class ClearCustomerGuard implements CanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    logger.debug('In ClearCustomerGuard');
    this.store.dispatch(new ClearSelectedCustomerAction());
    this.store.dispatch(goAction({ path: appSettings.SELECT_CUSTOMER_ROUTE }));
    return false;
  }
}
